import React from 'react';
import PropTypes from 'prop-types';
import {Box, Typography} from '@mui/material';
import EmptyMessageImage from '../../assets/empty-message.svg';

const EmptyMessage = ({setInputValue, sendMessage}) => {
  return (
    <Box className="empty-message-container">
      <img
        src={EmptyMessageImage}
        alt="Empty Message"
        className="empty-message-image"
      />

      <Box>
        <Typography variant="h3">Meet Penny</Typography>
        <Typography variant="body1" sx={{margin: '1rem 0'}}>
          I&apos;m Penny. I can answer questions about your document and search
          trusted sources like the SEC and FASB so you don&apos;t have to.
        </Typography>
        <Typography variant="body1" sx={{margin: '1rem 0'}}>
          You can ask me to:
        </Typography>
        <ul>
          <li>Answer questions about your draft</li>
          <li>
            Help explain disclosure requirements based on the latest guidance
          </li>
          <li>Spot inconsistencies or errors in your financials</li>
          <li>Search the SEC or FASB for relevant guidance and examples</li>
        </ul>
      </Box>
    </Box>
  );
};

EmptyMessage.propTypes = {
  setInputValue: PropTypes.func.isRequired,
  sendMessage: PropTypes.func.isRequired,
};

export default EmptyMessage;
